export type GoogleRecaptchaConfig = {
    googleClientId: string;
    recaptchaDisabled: boolean;
    recaptchaSiteKey: string;
};

export namespace GoogleRecaptchaConfig {
    export function fromProcessEnv(): GoogleRecaptchaConfig {
        return {
            googleClientId: process.env.GOOGLE_CLIENT_ID ?? '',
            recaptchaSiteKey: process.env.RECAPTCHA_SITE_KEY ?? '',
            recaptchaDisabled: process.env.RECAPTCHA_DISABLED === 'true',
        };
    }
}
